/**
 * RequireChurch - Route guard that ensures the user has a valid church assigned.
 * Redirects to /admin/church-setup if churchId is empty/null/Guid.Empty.
 * Must be used inside ProtectedRoute (user is guaranteed to be non-null).
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isEmptyChurchId } from '../utils/churchId';

export const RequireChurch: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  if (user && isEmptyChurchId(user.churchId)) {
    return <Navigate to="/admin/church-setup" replace />;
  }

  return <>{children}</>;
};
